import React from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteTwoTone';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import DownloadIcon from '@mui/icons-material/CloudDownload';
import VisibilityIcon from '@mui/icons-material/Visibility';

const ActionButtons = ({
  isEditing,
  onEdit,
  onDelete,
  onSave,
  onCancel,
  onDownload,
  onView,
  showEdit = true,
  showDelete = true,
  showDownload = false,
  showView = true
}) => {
  return (
    <Stack direction="row" spacing={1}>
      {isEditing ? (
        <>
          {onSave && (
            <Tooltip title="Enregistrer">
              <IconButton color="primary" onClick={onSave}>
                <SaveIcon />
              </IconButton>
            </Tooltip>
          )}
          {onCancel && (
            <Tooltip title="Annuler">
              <IconButton color="secondary" onClick={onCancel}>
                <CancelIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ) : (
        <>
          {showView && onView && (
            <Tooltip title="Voir">
              <IconButton color="info" onClick={onView}>
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          )}
          {showEdit && onEdit && (
            <Tooltip title="Modifier">
              <IconButton color="primary" onClick={onEdit}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          {showDownload && onDownload && (
            <Tooltip title="Télécharger">
              <IconButton color="primary" onClick={onDownload}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          )}
          {showDelete && onDelete && (
            <Tooltip title="Supprimer">
              <IconButton color="error" onClick={onDelete}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </Stack>
  );
};

export default ActionButtons;
